/**
 * Parse a date value from API (string or number) to a Date, or null if invalid.
 * - ISO string, "YYYY-MM-DD", or "YYYY-MM-DDTHH:mm:ss" supported
 * - Number: if < 1e12 treated as Unix seconds, else milliseconds
 */
export function parseDate(value: string | number | undefined | null): Date | null {
  if (value == null || value === '') return null;
  let date: Date;
  if (typeof value === 'number') {
    const ms = value < 1e12 ? value * 1000 : value;
    date = new Date(ms);
  } else {
    const s = String(value).trim();
    if (!s) return null;
    if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
      const [y, m, d] = s.split('-').map(Number);
      date = new Date(y, m - 1, d);
    } else {
      date = new Date(s);
    }
  }
  return Number.isNaN(date.getTime()) ? null : date;
}

/**
 * Format date for display: "Month day, year". Returns '' for invalid/missing.
 */
export function formatDate(date: string | number | undefined | null): string {
  const d = parseDate(date);
  if (!d) return '';
  return d.toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });
}

/**
 * Return timestamp (ms) for sorting. Invalid/missing → 0.
 */
export function dateToSortKey(date: string | number | undefined | null): number {
  const d = parseDate(date);
  return d ? d.getTime() : 0;
}